import jsPDF from 'jspdf';
import { isSqmMode, sqmLineDisplay } from './signageSqmUtils';

export const generateOrderConfirmationPDF = (oc, includeBOM = false) => {
  const pdf = new jsPDF(); const pw = 210; const m = 15; let y = 12;
  const spPhone = oc.salesman_phone || '';
  const contactLine = `www.prismoline.com | sales@prismoline.com${spPhone ? ' | +91 ' + spPhone : ''}`;
  pdf.setFillColor(36, 84, 156); pdf.rect(0, 0, pw, 38, 'F');
  pdf.setTextColor(255); pdf.setFontSize(18); pdf.setFont(undefined, 'bold');
  pdf.text('SHARDA INFRASOLUTIONS PVT. LTD.', m, 14);
  pdf.setFontSize(8); pdf.setFont(undefined, 'normal');
  pdf.text('Road Safety & Infrastructure Solutions', m, 22);
  pdf.setFontSize(7);
  pdf.text('CIN: U24100JH2010PTC014546 | PAN: AAPCS1562H', m, 28);
  pdf.text(contactLine, m, 34);
  y = 44;
  pdf.setTextColor(36, 84, 156); pdf.setFontSize(13); pdf.setFont(undefined, 'bold');
  pdf.text('ORDER CONFIRMATION', pw / 2, y, { align: 'center' }); y += 8;
  pdf.setDrawColor(36, 84, 156); pdf.line(m, y, pw - m, y); y += 6;
  pdf.setTextColor(0); pdf.setFontSize(8); pdf.setFont(undefined, 'bold');
  pdf.text(`OC No: ${oc.oc_number}`, m, y);
  const dateStr = oc.created_at ? new Date(oc.created_at).toLocaleDateString('en-IN') : '';
  pdf.text(`Date: ${dateStr}`, pw / 2, y); y += 5;
  if (oc.project_name) { pdf.text(`Project: ${oc.project_name}`, m, y); y += 5; }
  pdf.text(`Salesman: ${oc.salesman_name || ''}`, m, y); y += 8;

  // Bill To / Ship From — clean multi-line layout
  const custAddrLines = [oc.customer?.address, oc.customer?.city, [oc.customer?.state, oc.customer?.pincode].filter(Boolean).join(' - ')].filter(Boolean);
  const shipFromLines = oc.billing_address?.name ? [oc.billing_address.name, oc.billing_address.address, oc.billing_address.city, [oc.billing_address.state, oc.billing_address.pincode].filter(Boolean).join(' - ')].filter(Boolean) : [];
  const leftH = 14 + custAddrLines.length * 4 + (oc.customer?.gstin ? 4 : 0) + (oc.customer?.phone ? 4 : 0) + (oc.customer?.email ? 4 : 0);
  const rightH = shipFromLines.length > 0 ? 14 + shipFromLines.length * 4 + (oc.billing_address?.gstin ? 4 : 0) : 0;
  const boxH = Math.max(leftH, rightH, 28) + 4;
  const halfW = (pw - 2 * m - 4) / 2;

  // Bill To box
  pdf.setFillColor(245, 247, 250); pdf.rect(m, y, halfW, boxH, 'F');
  pdf.setTextColor(36, 84, 156); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
  pdf.text('BILL TO:', m + 3, y + 5);
  pdf.setTextColor(0); pdf.setFontSize(8); pdf.setFont(undefined, 'bold');
  pdf.text(oc.customer?.name || '', m + 3, y + 10);
  pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);
  let cY = y + 15;
  custAddrLines.forEach(l => { pdf.text(l, m + 3, cY); cY += 4; });
  if (oc.customer?.gstin) { pdf.text(`GSTIN: ${oc.customer.gstin}`, m + 3, cY); cY += 4; }
  if (oc.customer?.pan) { pdf.text(`PAN: ${oc.customer.pan}`, m + 3, cY); cY += 4; }
  if (oc.customer?.phone) { pdf.text(`Ph: ${oc.customer.phone}`, m + 3, cY); cY += 4; }
  if (oc.customer?.email) { pdf.text(`Email: ${oc.customer.email}`, m + 3, cY); }

  // Ship From box
  if (shipFromLines.length > 0) {
    const sfX = m + halfW + 4;
    pdf.setFillColor(245, 247, 250); pdf.rect(sfX, y, halfW, boxH, 'F');
    pdf.setTextColor(36, 84, 156); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    pdf.text('SHIP FROM:', sfX + 3, y + 5);
    pdf.setTextColor(0); pdf.setFontSize(8); pdf.setFont(undefined, 'bold');
    pdf.text('Sharda Infrasolutions Pvt Ltd', sfX + 3, y + 10);
    pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);
    let sY = y + 15;
    shipFromLines.forEach(l => { pdf.text(l, sfX + 3, sY); sY += 4; });
    if (oc.billing_address?.gstin) { pdf.text(`GSTIN: ${oc.billing_address.gstin}`, sfX + 3, sY); }
  }
  y += boxH + 4;

  // Ship To — dynamic height (show if any ship_to field has data)
  const hasShipTo = oc.ship_to && Object.values(oc.ship_to).some(v => v);
  if (hasShipTo) {
    const shipToLines = [oc.ship_to.name, oc.ship_to.address, [oc.ship_to.city, oc.ship_to.state, oc.ship_to.pincode].filter(Boolean).join(', ')].filter(Boolean);
    const stH = 10 + shipToLines.length * 4 + (oc.ship_to.contact_person ? 4 : 0);
    pdf.setFillColor(250, 250, 252); pdf.rect(m, y, pw - 2 * m, stH, 'F');
    pdf.setTextColor(36, 84, 156); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    pdf.text('SHIP TO (DELIVERY ADDRESS):', m + 3, y + 5);
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);
    let stY = y + 10;
    shipToLines.forEach(l => { pdf.text(l, m + 3, stY); stY += 4; });
    if (oc.ship_to.contact_person) { pdf.text(`Contact: ${oc.ship_to.contact_person} ${oc.ship_to.phone || ''}`, m + 3, stY); stY += 4; }
    if (oc.ship_to.gstin) { pdf.text(`GSTIN: ${oc.ship_to.gstin}`, m + 3, stY); }
    y += stH + 4;
  }

  // Consignee — dynamic height
  if (oc.consignee?.name) {
    const ca = [oc.consignee.address, oc.consignee.city, oc.consignee.state, oc.consignee.pincode].filter(Boolean).join(', ');
    const consLines = ca ? pdf.splitTextToSize(ca, 80) : [];
    const cH = 14 + consLines.length * 3.5;
    pdf.setFillColor(255, 252, 240); pdf.rect(m, y, pw - 2 * m, cH, 'F');
    pdf.setTextColor(100); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    pdf.text('CONSIGNEE (RECEIVING AUTHORITY):', m + 3, y + 5);
    pdf.setTextColor(0); pdf.setFontSize(8); pdf.setFont(undefined, 'bold');
    pdf.text(oc.consignee.name, m + 3, y + 10);
    pdf.setFont(undefined, 'normal'); pdf.setFontSize(7);
    consLines.forEach((l, i) => pdf.text(l, m + 50, y + 10 + i * 3.5));
    if (oc.consignee.gstin) pdf.text(`GSTIN: ${oc.consignee.gstin}`, pw / 2 + 15, y + 5);
    if (oc.consignee.contact_person) pdf.text(`Contact: ${oc.consignee.contact_person} ${oc.consignee.phone || ''}`, pw / 2 + 15, y + 10);
    y += cH + 4;
  }

  // Items table — clear gap
  y += 4;
  const isSignage = oc.oc_type === 'signage' && oc.signage_items?.length > 0;
  if (isSignage) {
    pdf.setFillColor(36, 84, 156); pdf.rect(m, y, pw - 2 * m, 7, 'F'); pdf.setTextColor(255); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    // Columns mirror the View (no Area): # | Description | Shape | Dimensions | Qty | Rate/Board | Amount
    ['#', 'Description', 'Shape', 'Dimensions', 'Qty', 'Rate', 'Amount'].forEach((h, i) => {
      pdf.text(h, [m + 2, m + 8, m + 78, m + 98, m + 120, m + 137, m + 158][i], y + 5);
    });
    y += 7; // bottom of header bar; rows begin directly below
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal');
    const tw = pw - 2 * m;
    // Compute actual line height from jsPDF internals so separator never cuts text
    const LINE_H = (pdf.getLineHeight ? pdf.getLineHeight() : 7 * 1.15) / pdf.internal.scaleFactor;
    const PAD_TOP = 3.5;  // space between row-top and first baseline
    const PAD_BOT = 3.5;  // breathing room below last baseline — prevents separator-through-text
    (oc.signage_items || []).forEach((item, idx) => {
      const effectiveRate = Number(item.custom_per_pcs_rate) || Number(item.per_board_rate) || Number(item.final_per_board) || 0;
      // Mixed work-type detection (OC side)
      const _siItems = oc.signage_items || [];
      const _wts = _siItems.map(si => si.work_type || '').filter(Boolean);
      const _mixedOC = Array.from(new Set(_wts)).length > 1;
      const _rowWT = item.work_type || '';
      const _wtTag = (_mixedOC && _rowWT) ? `[${_rowWT}]` : '';
      const _boardDesc = item.description || '-';
      const descLines = pdf.splitTextToSize(_wtTag ? `${_boardDesc}\n${_wtTag}` : _boardDesc, 68);
      // Spec description (smaller font) below the main desc + per-item discount note
      pdf.setFontSize(6.5);
      const _itemDisc = item.discount_amount || 0;
      const _discNote = _itemDisc > 0
        ? (item.disc_type === 'percent'
            ? `Discount: ${(item.disc_value || 0)}% (-INR ${Math.round(_itemDisc).toLocaleString('en-IN')})`
            : `Discount: -INR ${Math.round(_itemDisc).toLocaleString('en-IN')}`)
        : '';
      const _specCombined = [item.specific_description ? `Description: ${item.specific_description}` : '', _discNote].filter(Boolean).join('  •  ');
      const specLines = _specCombined ? pdf.splitTextToSize(_specCombined, 68) : [];
      pdf.setFontSize(7);
      const SPEC_H = (6.5 * 1.15) / pdf.internal.scaleFactor;
      const textH = descLines.length * LINE_H + specLines.length * SPEC_H + (specLines.length > 0 ? 1 : 0);
      const rowH = Math.max(8, textH + PAD_TOP + PAD_BOT);
      // Page break BEFORE drawing if row won't fit
      if (y + rowH > 272) { pdf.addPage(); y = 15; }
      // Zebra background covers the entire row
      if (idx % 2 === 1) {
        pdf.setFillColor(248, 249, 252);
        pdf.rect(m, y, tw, rowH, 'F');
      }
      pdf.setTextColor(0);
      const baseY = y + PAD_TOP; // first baseline
      pdf.text(`${idx + 1}`, m + 2, baseY);
      pdf.text(descLines, m + 8, baseY);
      pdf.text(`${item.shape || '-'}`, m + 78, baseY);
      pdf.text(`${item.dimensions || '-'}`, m + 98, baseY);
      if (isSqmMode(item)) {
        const { totalSqm, ratePerSqm } = sqmLineDisplay(item, item.qty, Number(item.total_amount) || 0);
        pdf.text(`${totalSqm} SQM`, m + 120, baseY);
        pdf.text(`${ratePerSqm.toLocaleString('en-IN')}`, m + 137, baseY);
      } else {
        pdf.text(`${item.qty || ''}`, m + 120, baseY);
        pdf.text(`${effectiveRate.toLocaleString('en-IN')}`, m + 137, baseY);
      }
      pdf.text(`${(item.total_amount || 0).toLocaleString('en-IN')}`, m + 158, baseY);
      if (specLines.length > 0) {
        pdf.setFontSize(6.5); pdf.setTextColor(100);
        pdf.text(specLines, m + 8, baseY + descLines.length * LINE_H + 1);
        pdf.setFontSize(7); pdf.setTextColor(0);
      }
      y += rowH;
      // Separator AT the bottom of the row (no overlap with text)
      pdf.setDrawColor(220); pdf.line(m, y, m + tw, y);
    });
  } else {
    pdf.setFillColor(36, 84, 156); pdf.rect(m, y, pw - 2 * m, 7, 'F'); pdf.setTextColor(255); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    ['#', 'Product', 'HSN', 'Qty', 'Unit', 'Rate', 'Disc%', 'Amount'].forEach((h, i) => { pdf.text(h, [m + 2, m + 10, m + 60, m + 82, m + 95, m + 108, m + 125, m + 140][i], y + 5); }); y += 9;
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal');
    const tw = pw - 2 * m;
    const LINE_H = (pdf.getLineHeight ? pdf.getLineHeight() : 7 * 1.15) / pdf.internal.scaleFactor;
    (oc.items || []).filter(item => item.product_id || item.product || (item.product_name && item.product_name.trim()) || Number(item.qty) > 0 || Number(item.rate) > 0).forEach((item, idx) => {
      const name = item.product_name || '';
      const nameLines = pdf.splitTextToSize(name, 45);
      const descLines = item.description ? pdf.splitTextToSize(item.description, 45) : [];
      const totalLines = nameLines.length + descLines.length;
      const rowH = Math.max(6, totalLines * 3.5 + 2);
      if (y + rowH > 265) { pdf.addPage(); y = 15; }
      if (idx % 2 === 0) { pdf.setFillColor(248, 249, 252); pdf.rect(m, y - 2, tw, rowH + 2, 'F'); }
      pdf.setTextColor(0);
      pdf.setFont(undefined, 'bold');
      pdf.text(`${idx + 1}`, m + 2, y);
      nameLines.forEach((ln, k) => pdf.text(ln, m + 10, y + k * 3.5));
      if (descLines.length > 0) {
        pdf.setFont(undefined, 'normal');
        pdf.setTextColor(100);
        descLines.forEach((ln, k) => pdf.text(ln, m + 10, y + nameLines.length * 3.5 + k * 3.5));
        pdf.setTextColor(0);
      }
      pdf.setFont(undefined, 'normal');
      pdf.text(item.hsn_code || '', m + 60, y);
      pdf.text(`${item.qty || ''}`, m + 82, y);
      pdf.text(item.unit || '', m + 95, y);
      pdf.text(`${(item.rate || 0).toLocaleString('en-IN')}`, m + 108, y);
      pdf.text(`${item.discount || 0}%`, m + 125, y);
      pdf.text(`${(item.amount || 0).toLocaleString('en-IN')}`, m + 140, y);
      y += rowH;
      pdf.setDrawColor(220); pdf.line(m, y, m + tw, y);
    });
  }
  y += 3; pdf.setDrawColor(36, 84, 156); pdf.setLineWidth(0.5); pdf.line(m, y, pw - m, y); pdf.setLineWidth(0.2); y += 6; pdf.setFontSize(8);
  const totValR = pw - m;  // right-align totals values to avoid label/value overlap
  if ((oc.discount_amount || 0) > 0) {
    pdf.setFont(undefined, 'normal'); pdf.text('Net Total:', m + 100, y); pdf.setFont(undefined, 'bold'); pdf.text(`INR ${(oc.net_total || oc.subtotal || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' }); y += 6;
    pdf.setFont(undefined, 'normal'); pdf.text(`Discount${oc.discount_type === 'percent' ? ' (' + oc.discount_value + '%)' : ''}:`, m + 100, y); pdf.text(`- INR ${(oc.discount_amount || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' }); y += 6;
    pdf.text('Taxable Value:', m + 100, y); pdf.setFont(undefined, 'bold'); pdf.text(`INR ${(oc.subtotal || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' }); y += 6;
  } else {
    pdf.text('Subtotal:', m + 100, y); pdf.setFont(undefined, 'bold'); pdf.text(`INR ${(oc.subtotal || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' }); y += 6;
  }
  // Other charges (freight, packing, etc.) — mirror the View, before GST
  (oc.other_charges || []).forEach(ch => {
    pdf.setFont(undefined, 'normal');
    const label = `${ch.description || 'Other Charge'}${ch.taxable !== false ? ' (+GST)' : ''}:`;
    pdf.text(label, m + 100, y);
    pdf.text(`INR ${(ch.amount || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' });
    y += 6;
  });
  pdf.setFont(undefined, 'normal'); pdf.text(`GST (${oc.gst_rate || 18}%):`, m + 100, y); pdf.text(`INR ${(oc.gst_amount || 0).toLocaleString('en-IN')}`, totValR, y, { align: 'right' }); y += 6;
  pdf.setFillColor(36, 84, 156); pdf.rect(m + 95, y - 4, pw - m - (m + 95), 8, 'F');
  pdf.setTextColor(255); pdf.setFont(undefined, 'bold'); pdf.setFontSize(9);
  pdf.text('Total:', m + 100, y + 1); pdf.text(`INR ${(oc.total || 0).toLocaleString('en-IN')}`, totValR - 2, y + 1, { align: 'right' }); y += 14;
  pdf.setTextColor(36, 84, 156); pdf.setFontSize(8); pdf.setFont(undefined, 'bold');
  pdf.text('Terms & Conditions', m, y); y += 6;
  pdf.setTextColor(60); pdf.setFontSize(7); pdf.setFont(undefined, 'normal');
  Object.entries(oc.terms || {}).forEach(([key, val]) => { if (!val) return; const label = key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()); pdf.setFont(undefined, 'bold'); pdf.text(`${label}: `, m, y); pdf.setFont(undefined, 'normal'); pdf.text(String(val), m + 30, y); y += 5; if (y > 275) { pdf.addPage(); y = 15; } });
  y = Math.max(y + 8, 268); pdf.setDrawColor(36, 84, 156); pdf.line(m, y, pw - m, y); y += 4;
  pdf.setFontSize(6); pdf.setTextColor(130); pdf.text('This is a system-generated Order Confirmation from Prismoline ERP. This is not a tax invoice.', pw / 2, y, { align: 'center' });
  if (includeBOM && isSignage && oc.bom_items?.length > 0) {
    pdf.addPage(); y = 15; pdf.setFillColor(36, 84, 156); pdf.rect(0, 0, pw, 22, 'F');
    pdf.setTextColor(255); pdf.setFontSize(12); pdf.setFont(undefined, 'bold'); pdf.text('BILL OF MATERIALS (BOM)', m, 14);
    pdf.setFontSize(7); pdf.setFont(undefined, 'normal'); pdf.text(`OC: ${oc.oc_number} | Project: ${oc.project_name || '-'}`, m, 19); y = 30;
    pdf.setFillColor(36, 84, 156); pdf.rect(m, y, pw - 2 * m, 7, 'F'); pdf.setTextColor(255); pdf.setFontSize(7); pdf.setFont(undefined, 'bold');
    ['#', 'Material', 'Description', 'HSN', 'Qty', 'Unit'].forEach((h, i) => { pdf.text(h, [m + 2, m + 12, m + 50, m + 110, m + 135, m + 155][i], y + 5); }); y += 9;
    pdf.setTextColor(0); pdf.setFont(undefined, 'normal');
    (oc.bom_items || []).forEach((item, idx) => { pdf.text(`${idx + 1}`, m + 2, y); pdf.text(item.material || '', m + 12, y); const desc = item.description?.length > 40 ? item.description.substring(0, 40) + '...' : item.description || ''; pdf.text(desc, m + 50, y); pdf.text(item.hsn_code || '', m + 110, y); pdf.text(`${item.qty || ''}`, m + 135, y); pdf.text(item.unit || '', m + 155, y); y += 6; if (y > 270) { pdf.addPage(); y = 15; } });
    y += 5; pdf.setFontSize(6); pdf.setTextColor(130); pdf.text('BOM for consumption entry in Tally. Rates to be filled as per purchase costs.', m, y);
  }
  return pdf;
};
